export default __webpack_public_path__ + "static/media/470.6cb9a80f.gif";